import React, { Component } from 'react'
import PropTypes from 'prop-types'

import UserStat from './UserStat'
import {
  displayNumberRoundedToTenth,
  displayNumberAsPercentage
} from '../../utils'
import {
  hasCompletedQuests,
  formatQuestCountDisplay
} from '../../utils/userstats'

export default class UserStats extends Component {
  render() {
    const { stats } = this.props
    const hasNoCompletedQuests = !hasCompletedQuests(stats)

    return (
      <div className="user-stats">
        <div className="line" />

        <UserStat
          type="average_learner_rating"
          value={displayNumberRoundedToTenth(stats.average_learner_rating)}
          hasNoCompletedQuests={hasNoCompletedQuests}
        />
        <div className="line" />

        <UserStat
          type="average_learner_effort"
          value={displayNumberRoundedToTenth(stats.average_learner_effort)}
          hasNoCompletedQuests={hasNoCompletedQuests}
        />
        <div className="line" />

        <UserStat
          type="percent_quests_recommended"
          value={displayNumberAsPercentage(stats.percent_quests_recommended)}
          hasNoCompletedQuests={hasNoCompletedQuests}
        />
        <div className="line" />

        <UserStat
          type="quests_in_progress_by_learners_count"
          value={formatQuestCountDisplay(
            stats.quests_in_progress_by_learners_count
          )}
        />
        <div className="line" />

        <UserStat
          type="quests_completed_by_learners_count"
          value={formatQuestCountDisplay(
            stats.quests_completed_by_learners_count
          )}
        />
      </div>
    )
  }
}

UserStats.propTypes = {
  stats: PropTypes.object.isRequired
}



// WEBPACK FOOTER //
// ./src/components/myquests/UserStats.js